export enum ChartLabelStyle
{
    None = "none",
    Inner = "inner",
    Outer = "outer"
}